import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCategoriesSorted, getSubcategories } from '../../data/categories';
import './CategoryExclusionFilter.css';

/**
 * Компонент для исключения категорий из поиска
 * Позволяет выбрать категории, которые нужно исключить из результатов
 */
function CategoryExclusionFilter({ excludedCategories, onToggleExclusion }) {
  const { t } = useTranslation();
  const [expandedCategory, setExpandedCategory] = useState(null);
  const categoriesList = getCategoriesSorted();

  const toggleCategory = (categoryId) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  const toggleSubcategory = (subcategory) => {
    onToggleExclusion(subcategory);
  };

  const isSubcategoryExcluded = (subcategory) => {
    return excludedCategories.includes(subcategory);
  };

  return (
    <div className="categoryExclusionFilter">
      <h4 className="categoryExclusionFilterTitle">
        {t('search.excludeCategories')}
      </h4>
      <p className="categoryExclusionFilterHint">
        {t('search.excludeCategoriesHint')}
      </p>
      
      <div className="categoryExclusionList">
        {categoriesList.map((category) => {
          const subcategories = getSubcategories(category.name);
          
          if (subcategories.length === 0) return null;

          return (
            <div key={category.id} className="categoryExclusionItem">
              <button
                type="button"
                className={`categoryExclusionCategoryButton ${
                  expandedCategory === category.id ? 'expanded' : ''
                }`}
                onClick={() => toggleCategory(category.id)}
              >
                <span>{t(`categories.${category.id}`)}</span>
                <span className="categoryExclusionArrow">
                  {expandedCategory === category.id ? '▼' : '▶'}
                </span>
              </button>
              
              {expandedCategory === category.id && (
                <div className="categoryExclusionSubcategories">
                  {subcategories.map((subcategory) => (
                    <label
                      key={subcategory}
                      className="categoryExclusionSubcategoryLabel"
                    >
                      <input
                        type="checkbox"
                        checked={isSubcategoryExcluded(subcategory)}
                        onChange={() => toggleSubcategory(subcategory)}
                        className="categoryExclusionCheckbox"
                      />
                      <span className="categoryExclusionSubcategoryName">
                        {t(`subcategories.${subcategory.toLowerCase().replace(/[^a-z0-9]/g, '-')}`)}
                      </span>
                    </label>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      {excludedCategories.length > 0 && (
        <div className="categoryExclusionSummary">
          <button
            type="button"
            className="categoryExclusionClearButton"
            onClick={() => onToggleExclusion(null, true)}
          >
            {t('search.clearExclusions')} ({excludedCategories.length})
          </button>
        </div>
      )}
    </div>
  );
}

export default CategoryExclusionFilter;